import clsx from 'clsx';
import React, { forwardRef, useMemo } from 'react';
import { Icon } from '../../icon';
import { BaseButton } from '../base-button';
import styles from './styles.module.css';
/**
 * `<IconButton />` —  Кнопка, состоящая из одной иконки.
 *
 * @example ```tsx
 * <IconButton aria-label="icon-button"><SampleIcon/></IconButton>
 * ```
 */
export const IconButton = /*#__PURE__*/forwardRef(function IconButton({
  className = '',
  variant = 'primary',
  children,
  size = 'm',
  label,
  'aria-label': ariaLabel,
  invert = false,
  ...props
}, ref) {
  const usedVariant = variant === 'invert' ? 'primary' : variant;
  const usedInvert = invert || variant === 'invert';
  const classNames = useMemo(() => clsx(styles.iconButton, styles[usedVariant], className, {
    [styles.invert]: usedInvert
  }), [usedVariant, className, usedInvert]);
  const iconSize = size ? iconSizesByButtonSize[size] : 0;
  return /*#__PURE__*/React.createElement(BaseButton, {
    "data-variant": usedVariant,
    "data-invert": usedInvert ? '+' : '-',
    className: classNames,
    ref: ref,
    "aria-label": label != null ? label : ariaLabel,
    ...props
  }, /*#__PURE__*/React.createElement(Icon, {
    size: iconSize
  }, children));
});
const iconSizesByButtonSize = {
  s: 16,
  m: 20,
  l: 24
};